export const SET_WORLD_SEARCH = 'worldSearch/SET_WORLD_SEARCH';
